import { Layout } from "antd";
import { MenuLateral } from "shared/components";
import "./Layout.scss";
import { isMobile } from "react-device-detect";

const { Content } = Layout;

const LayoutAdiantamento: React.FC<{ children?: React.ReactNode }> = (
  props
) => {
  const { children } = props;

  return (
    <Layout
      className={`layout-mobile layout-adiantamento ${
        isMobile ? "is-mobile" : "is-web"
      }`}
    >
      <MenuLateral />
      <Content className="mobile-content">
        <div className="mobile-content-centralizado">{children}</div>
      </Content>
    </Layout>
  );
};

export default LayoutAdiantamento;
